<section class="login-wrap">
    <div class="design-section">
        <svg width="419" height="666" viewBox="0 0 419 666" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 100C0 44.7715 44.7715 0 100 0H125V147C125 202.228 80.2285 247 25 247H0V100Z" fill="#2D3653" />
            <path d="M125 100C125 44.7715 169.772 0 225 0H233V114C233 169.228 188.228 214 133 214H125V100Z"
                fill="#F0F2F1" />
            <path d="M107 568C107 622.124 150.876 666 205 666V569C205 514.876 161.124 471 107 471V568Z"
                fill="#F0F2F1" />
            <path
                d="M221 471C276.228 471 321 426.228 321 371L321 363L207 363C151.772 363 107 407.772 107 463L107 471L221 471Z"
                fill="#F0F2F1" />
            <path
                d="M166 310C166 284.595 186.595 264 212 264C237.405 264 258 284.595 258 310V313C258 340.062 236.062 362 209 362H166V310Z"
                fill="#FF743D" />
            <path d="M66 47.2C66 21.1322 87.1322 0 113.2 0H125V69.384C125 95.4518 103.868 116.584 77.8 116.584H66V47.2Z"
                fill="#6DD47B" />
            <path
                d="M16 352.676C16 330.764 33.7636 313 55.6761 313H65.5951V371.324C65.5951 393.236 47.8315 411 25.919 411H16V352.676Z"
                fill="#6DD47B" />
            <path
                d="M349.676 262C327.764 262 310 279.764 310 301.676L310 311.595L368.324 311.595C390.236 311.595 408 293.832 408 271.919L408 262L349.676 262Z"
                fill="#2D3653" />
            <path
                d="M66 303.676C66 281.764 83.7636 264 105.676 264H115.595V322.324C115.595 344.236 97.8315 362 75.919 362H66V303.676Z"
                fill="#D4E155" />
            <path
                d="M300.676 312C278.764 312 261 329.764 261 351.676L261 361.595L319.324 361.595C341.236 361.595 359 343.832 359 321.919L359 312L300.676 312Z"
                fill="#6DD47B" />
            <path
                d="M165.595 303.676C165.595 281.764 147.832 264 125.919 264H116V322.324C116 344.236 133.764 362 155.676 362H165.595V303.676Z"
                fill="#2D3653" />
            <path
                d="M125 144.2C125 118.132 146.132 97 172.2 97H184V166.384C184 192.452 162.868 213.584 136.8 213.584H125V144.2Z"
                fill="#D4E155" />
            <path
                d="M107 529.8C107 555.868 128.132 577 154.2 577H161V518.2C161 492.132 139.868 471 113.8 471H107V529.8Z"
                fill="#FFC700" />
            <path
                d="M176.384 471C202.452 471 223.584 449.868 223.584 423.8L223.584 412L154.2 412C128.132 412 107 433.132 107 459.2L107 471L176.384 471Z"
                fill="#FF743D" />
            <circle cx="47" cy="280" r="16" fill="#FF743D" />
            <circle cx="40" cy="444" r="16" fill="#FF743D" />
            <circle cx="392" cy="346" r="16" fill="#FF743D" />
            <circle cx="86" cy="444" r="16" fill="#2D3653" />
            <circle cx="277" cy="280" r="16" fill="#6DD47B" />
            <circle cx="86" cy="395" r="16" fill="#6DD47B" />
            <path d="M107 471V568H10C10 514.456 53.456 471 107 471Z" fill="#FE5E33" />
            <path d="M322 568V471H419C419 524.544 375.544 568 322 568Z" fill="#FE5E33" />
            <path d="M225 665V568H322C322 621.544 278.544 665 225 665Z" fill="#FE5E33" />
            <path d="M10 568L107 568L107 665C53.456 665 10 621.544 10 568Z" fill="#D4E155" />
            <path d="M225 471L322 471L322 568C268.456 568 225 524.544 225 471Z" fill="#D4E155" />
            <path d="M54 568L107 568L107 621C77.744 621 54 597.256 54 568Z" fill="#2D3653" />
            <path d="M269 471L322 471L322 524C292.744 524 269 500.256 269 471Z" fill="#2D3653" />
            <path d="M233 89.2L233 7.47816e-06L322 1.52588e-05C322 49.2384 282.128 89.2 233 89.2Z" fill="#FF743D" />
        </svg>
    </div>
    <div class="login-form-wrap">
        <div class="logo-head text-right">
            <img src="../../../assets/svgs/title-logo.svg">
        </div>
        <form class="resetform" [formGroup]="resetForm" (ngSubmit)="setPassword()">
            <div class="form-title text-center w-100">
                <h2>Welcome to <span>ToonSutra !</span></h2>
                <h4 class="mr-t40 mr-b40">Please set your password.</h4>
            </div>
            <div class="w-100">
                <div class="form-group">
                    <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>Enter new password</mat-label>
                        <input matInput type="password" formControlName="password" maxlength="128"
                            [ngClass]="{ 'is-invalid':f.password.invalid &&(f.password.dirty || f.password.touched||submitted)}"
                            required>
                        <div *ngIf="f.password.invalid &&(f.password.dirty || f.password.touched||submitted)"
                            class="invalid-feedback error">
                            <div *ngIf="f.password.errors.required">Password required</div>
                            <div *ngIf="f.password.errors.pattern">Password must contain at least 6 characters ,
                                including uppercase, lowercase letters , numbers and special character.</div>
                        </div>
                    </mat-form-field>
                </div>
                <div class="form-group">
                    <mat-form-field appearance="outline">
                        <mat-label>Confirm password</mat-label>
                        <input matInput type="password" formControlName="confirmPassword" maxlength="128"
                            [ngClass]="{ 'is-invalid':f.confirmPassword.invalid &&(f.confirmPassword.dirty || f.confirmPassword.touched||submitted)}"
                            required>
                        <div *ngIf="f.confirmPassword.invalid &&(f.confirmPassword.dirty || f.confirmPassword.touched||submitted)"
                            class="invalid-feedback error">
                            <div *ngIf="f.confirmPassword.errors.required">Password required</div>
                            <div *ngIf="f.confirmPassword.errors.confirmedValidator">
                                Password doesn't match
                            </div>
                        </div>
                    </mat-form-field>
                </div>
                <button type="submit" class="purpul-btn full-btn login-btn">Change Password</button>
                <div class="text-center">
                    <a routerLink="/">Return to login</a>
                </div>
            </div>
        </form>
    </div>
    <div class="rigth-bottom-svg">
        <svg width="92" height="98" viewBox="0 0 92 98" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M92 46C92 20.5949 71.4051 0 46 0C20.5949 0 0 20.5949 0 46V49C0 76.062 21.938 98 49 98H92V46Z"
                fill="#FF743D" />
        </svg>
    </div>
</section>